module.exports = __webpack_public_path__ + "img/19_90.48e6fcd4.png";